import React from "react";
import { Form } from "react-crud-form";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { useNavigate } from "react-router-dom";
import { teamSchema } from "./schema";
import { FormActions } from "components/form/actions";
import { useTeamForm } from "./useTeamForm";
import EmployeeInput from "components/employee/input";
import EmployeeMultiSelectSheet from "components/employee/multiselect-sheet";
import { FormLabel } from "components/form";
import SelectStatus from "components/select/status";
import SelectName from "components/select/name";

const TeamForm = ({ teamId }) => {
  const navigate = useNavigate();
  const { form, handleCreate, handleUpdate, handleRead } = useTeamForm({
    teamId,
  });

  return (
    <Form
      form={form}
      create={handleCreate}
      update={handleUpdate}
      read={handleRead}
      itemId={teamId || "+"}
      schema={teamSchema}
    >
      {({
        isCreating,
        createItem,
        isNewItem,
        updateItem,
        isUpdating,
        isDirty,
      }) => (
        <div className="space-y-6">
          {/* Department Field */}
          <FormField
            control={form.control}
            name="department"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Department</FormLabel>
                <SelectName
                  collection="departments"
                  onValueChange={val => field.onChange(val)}
                  fetchItems={true}
                  value={field.value?.id || field.value}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="status"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Status</FormLabel>
                <SelectStatus
                  collection="teams"
                  onValueChange={val => field.onChange(val)}
                  {...field}
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="lead"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Lead</FormLabel>
                <EmployeeInput {...field} />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="employees"
            render={({ field }) => (
              <FormItem>
                <FormLabel required>Employees</FormLabel>
                <EmployeeMultiSelectSheet
                  value={field.value}
                  onChange={val => field.onChange(val)}
                  placeholder="Select Team Members"
                  filter={{ status: { user: { _eq: 'active' }} }}
                  info="Select multiple employees to add to this team"
                />
                <FormMessage />
              </FormItem>
            )}
          />

          <FormActions
            isNewItem={isNewItem}
            isCreating={isCreating}
            isUpdating={isUpdating}
            isDirty={isDirty}
            createItem={() => createItem().then(() => navigate(-1))}
            updateItem={() => updateItem().then(() => navigate(-1))}
            showCancel={false}
            collection="teams"
            rule={isNewItem ? "create:*" : "update:*"}
          />
        </div>
      )}
    </Form>
  );
};

export default TeamForm;
